<template>
  <div>
    <div v-if="customer.id || createMode">
      <customer-edit
        v-bind:customer="customer"
        :title="title"
        @saved="updateCustomer"
      >
      </customer-edit>
    </div>
    <loading-content
      v-else
      :loading="loading"
      empty-icon="person_outline"
      empty-label="Cliente no encontrado."
    >
      <!--
      <md-button> Regresar </md-button>  
    -->
    </loading-content>
  </div>
</template>

<script>

import catalogService from '@/services/catalog'
import CustomerEdit from "./Edit"
import setsPageTitleMixin from '@/mixins/setsPageTitle'

export default {

  name: 'Update',

  props: {
    id: {
      type: String,
      default: ""
    }
  },

  components: {
    CustomerEdit
  },

  mixins: [setsPageTitleMixin],

  data () {
    return {
      loading: null,
      customer: {
        // id: null,
        // contacData: {
        //   phone: 333,
        //   address: {}
        // },
        // fiscalData: {
        //   fiscalAddress: {}
        // }
      },
      createMode: false,
      title: 'Editar cliente'
    }
  },
  created() {
    this.loading = true
    if (this.id !== 'nuevo') {
      this.createMode = false
      catalogService.fetch('customer', this.id)
        .then((customer) => {
          this.loading = false
          this.customer = customer
        }).catch(error => {
          this.loading = false
          throw error
        })
    } else {
      this.title = 'Crear cliente'
      this.createMode = true
    }
  },
  computed: {
    pageTitle() {
      const { customer } = this

      if (!customer.id) {
        return
      }

      return `Editar Cliente: ${customer.name}`
    }
  },
  methods: {
    updateCustomer({original, updated}) {
      if(!original.id){
        catalogService.create('customer', updated)
          .then((customer) => {
            this.$successMessage({ title: `Creado nuevo cliente: ${customer.name}`})
            this.$router.push({name: 'Clientes'})
          })
          .catch(this.$fireErrorResponse)
      } else {
        catalogService.update('customer', updated, original)
          .then((customer) => {
            this.$successMessage({ title: `${customer.name} fue actualizado`})
            this.$router.push({name: 'Clientes'})
          }, this.$fireErrorResponse)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Customers/Update.vue